import React from "react";
import ResourseButtons from "../../../components/form/buttons/ResourseButtons";
import { useDispatch, useSelector } from "react-redux";
import { FilePenLine, TriangleAlert } from "lucide-react";
import { useForm } from "react-hook-form";
import TextAreaField from "../../../components/form/TextAreaField";
import InputField from "../../../components/form/InputField";
import { useNavigate } from "react-router-dom";
import {
  addProvincialReqReject,
  addProvincialTotalReqReject,
} from "../../../features/projectsSlice";
import { closeModal } from "../../../features/modalSLice";
import { useNotification } from "../../../components/notification/NotificationContainer";
import { zodResolver } from "@hookform/resolvers/zod";
import { addRequestRejectSchema } from "../../../schemas";

const AddProvincialRejection = ({ id, name, reject }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const addNotification = useNotification();
  const loading = useSelector(
    (state) => state.projects.load.addProvincialReqReject
  );
  const loading2 = useSelector(
    (state) => state.projects.load.addProvincialTotalReqReject
  );

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: { id: id },
    resolver: zodResolver(addRequestRejectSchema),
  });

  const onSubmit = async (data) => {
    try {
      let res;
      if (reject) {
        res = await dispatch(addProvincialTotalReqReject(data));
        if (addProvincialTotalReqReject.fulfilled.match(res)) {
          dispatch(closeModal());
          addNotification("Project canceled!", "success");
          return navigate("/requests/provincial-approvals");
        } else {
          addNotification(res.payload.message, "error");
          if (res.payload.code === 412) {
            dispatch(closeModal());
            navigate("/requests/provincial-approvals");
          }
        }
      } else {
        res = await dispatch(addProvincialReqReject(data));
        if (addProvincialReqReject.fulfilled.match(res)) {
          dispatch(closeModal());
          addNotification("Project ammended successfully", "success");
          return navigate("/requests/provincial-approvals");
        } else {
          addNotification(res.payload.message, "error");
          if (res.payload.code === 412) {
            dispatch(closeModal());
            navigate("/requests/provincial-approvals");
          }
        }
      }
    } catch (error) {
      addNotification(error.message, "warning");
    }
  };

  return (
    <>
      {id && (
        <div className="min-w-[85vw] sm:min-w-[35rem] lg:min-w-[50rem] max-w-4xl w-full text-text-1/80">
          <div className="flex  justify-center items-center gap-2 py-3 border-b border-bkg2 mb-4 text-text-1/80">
            {reject ? <TriangleAlert /> : <FilePenLine />}
            <h4>{reject ? "Decline Request" : "Amend Request"}</h4>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            {reject ? (
              <p className="mb-4 flex gap-2">
                Reject
                <span className="font-extrabold text-red-500">{name}</span>
              </p>
            ) : (
              <p className="mb-4 flex gap-2">{name}</p>
            )}
            <TextAreaField
              register={register}
              label="Comment"
              name="comment"
              errors={errors.comment}
              red={reject}
            />
            <InputField
              register={register}
              name="id"
              type="hidden"
              defaultValue={id}
            />
            <ResourseButtons
              loading={loading || loading2}
              red={reject}
              submitText={reject ? "Decline" : "Amend"}
            />
          </form>
        </div>
      )}
    </>
  );
};

export default AddProvincialRejection;
